import { SpriteIcon } from './sprite-icon.tsx'

export const chevronsSymbols = [
  <symbol key='icon-chevron-down' id='icon-chevron-down' viewBox='0 0 12 12'>
    <path
      d='M0.16 3.4C0.4 3.13 0.82 3.1 1.1 3.33L6.09 7.36L10.89 3.34C11.16 3.11 11.59 3.13 11.83 3.39C12.08 3.64 12.05 4.04 11.78 4.27L6.55 8.66C6.3 8.87 5.92 8.88 5.67 8.67L0.23 4.28C-0.05 4.05 -0.08 3.66 0.16 3.4Z'
      fill='currentColor'
    />
  </symbol>,
  <symbol key='icon-chevron-right' id='icon-chevron-right' viewBox='0 0 20 20'>
    <path
      d='M5.66 0.27C5.22 0.67 5.17 1.37 5.55 1.83L12.27 10.16L5.56 18.15C5.18 18.61 5.21 19.31 5.64 19.72C6.07 20.13 6.74 20.09 7.12 19.63L14.44 10.91C14.79 10.49 14.79 9.87 14.45 9.45L7.13 0.39C6.76 -0.08 6.1 -0.13 5.66 0.27Z'
      fill='currentColor'
    />
  </symbol>,
  <symbol key='icon-chevron-left' id='icon-chevron-left' viewBox='0 0 20 20'>
    <path
      d='M14.34 19.73C14.78 19.33 14.83 18.63 14.45 18.17L7.73 9.84L14.44 1.85C14.82 1.39 14.79 0.69 14.36 0.28C13.93 -0.13 13.26 -0.09 12.88 0.37L5.56 9.09C5.21 9.51 5.21 10.13 5.55 10.55L12.87 19.61C13.24 20.08 13.9 20.13 14.34 19.73Z'
      fill='currentColor'
    />
  </symbol>,
  <symbol key='icon-chevron-up' id='icon-chevron-up' viewBox='0 0 16 16'>
    <path
      d='M0.21 11.47C0.53 11.82 1.1 11.86 1.47 11.56L8.12 6.18L14.52 11.55C14.89 11.86 15.45 11.83 15.77 11.49C16.1 11.14 16.07 10.61 15.7 10.3L8.73 4.45C8.4 4.17 7.9 4.16 7.56 4.44L0.31 10.29C-0.06 10.59 -0.11 11.12 0.21 11.47Z'
      fill='currentColor'
    />
  </symbol>
]

export function ChevronDown ({ className }: { className?: string }): JSX.Element {
  return <SpriteIcon id='icon-chevron-down' size={12} className={className} />
}

export function ChevronRight ({ className }: { className?: string }): JSX.Element {
  return <SpriteIcon id='icon-chevron-right' size={20} className={className} />
}

export function ChevronLeft ({ className }: { className?: string }): JSX.Element {
  return <SpriteIcon id='icon-chevron-left' size={20} className={className} />
}

export function ChevronUp ({ className }: { className?: string }): JSX.Element {
  return <SpriteIcon id='icon-chevron-up' size={16} className={className} />
}
